import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import Translate from 'translate';
import async from 'async';

import ChannelCaseService from 'services/ChannelCaseService';
import { FormGroup, Text, Textarea, Select } from 'components/FormElements';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import { required, validFixedLine } from 'constants/InputErrors';
import IncmsService from 'services/IncmsService';

class AddImsNoAccountModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      options: {},
      options2: {},
      streets: null,
      divisions: null,
      locations: null,
      districs: null,
      landmark: null,
      codProvince: null,
      codDivision: null,
      codDistrict: null,
      codLocation: null,
      codStreet: null,
      phoneNumber: null,
      imsNature: null , 
      imsScope: null, 
      registerComment: null
    };
    this.setDistrict = this.setDistrict.bind( this );
    this.setDivision = this.setDivision.bind( this );
    this.setLocation = this.setLocation.bind( this );
    this.setStreet = this.setStreet.bind( this );

    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( !this.props.open && nextProps.open ) {
      this.setState( { landmark: null } );
      this.getData()
    }
  }


  setDistrict = cod_pro => {
    this.props.toggleLoading( true );
    IncmsService.getDistric( cod_pro ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ){
        this.setState ( {
          codProvince:cod_pro, 
          codDistrict: null, 
          codDivision: null,
          divisions: null,
          codLocation: null,
          locations:null,
          codStreet: null,
          streets: null,
          districs: _.orderBy( response.data, 'description' )} )
      }
    } )
  };


  setDivision = cod_district => {
    this.props.toggleLoading( true );
    IncmsService.getDivision( cod_district ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ){
        this.setState ( { 
          codDistrict: cod_district, 
          codDivision: null,
          codLocation: null,
          locations:null,
          codStreet: null,
          streets: null,
          divisions: _.orderBy( response.data, 'description' )} )
      }
    } )
  };


  setLocation = cod_division => {
    this.props.toggleLoading( true );
    IncmsService.getLocation( cod_division ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ){
        this.setState ( {
          codDivision: cod_division, 
          codLocation: null,
          locations:null,
          codStreet: null,
          streets: null,
          locations: _.orderBy( response.data, 'description' )} )
      }
    } )
  };

  setStreet = cod_location => {
    this.props.toggleLoading( true );
    IncmsService.getStreet( cod_location ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ){
        this.setState ( {codLocation: cod_location,  streets: _.orderBy( response.data, 'description' )} )
      }
    } )
  };
  setStateStreet = cod_street => {

    this.setState ( {codStreet: cod_street } )
      

  };
  getData() {
    this.props.toggleLoading( true );

    async.parallel( {
      options: ( cb ) => {
        IncmsService.getImsData().then( ( response ) => {
          if( !response.data ) return cb();
          return cb( null, {
            nature: _.orderBy( response.data.imsNature, 'nature' ),
            scope: _.orderBy( response.data.imsScope, 'scope' )
          } );

        } )

      },
      options2: ( cb ) => {

        IncmsService.getProvince().then( ( response ) => {
          if( !response.data ) return cb();
          return cb( null, {
            province: _.orderBy( response.data, 'description' ),
          } );

        } )
      },
      /*landmark: ( cb ) => {
        IncmsService.getLandmark( this.props.activeAccount.id ).then( ( response ) => {
          if( !response.data ) return cb();
          return cb( null, response.data && response.data.landmark ? response.data.landmark : null );
        } )
      }*/
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( results ) this.setState( results )
    } )
  }

  submitForm( data ) {
    const { channel, onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;

    toggleLoading( true );

    data.channel = channel.id;
    data.typeCase = 'ims';
    // data.account = this.props.activeAccount.id;

    let dataToSend = {
      "codStreet": data.codStreet,
      "channel": channel.id,
      "imsLandmark": data.imsLandmark,
      "imsNature": data.imsNature,
      "imsScope": data.imsScope,
      "phoneNumber": data.phoneNumber,
      "registerComment": data.registerComment,
      "typeCase": "ims"
    };
    this.setState ({codStreet: data.codStreet, phoneNumber: data.phoneNumber, imsNature: data.imsNature, imsScope: data.imsScope, registerComment: data.registerComment});
    ChannelCaseService.saveCase( dataToSend ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) {
        toggleAlertError( response.errors );
        this.setState ( {
          streets: null,
          divisions: null,
          locations: null,
          districs: null,
          landmark: null,
          codProvince: null,
          codDivision: null,
          codDistrict: null,
          codLocation: null,
          codStreet: null,
          phoneNumber: null,
          imsNature: null , 
          imsScope: null, 
          registerComment: null,}
        );
        onClose();
        return 
      
      }

      this.props.toggleAlertError( `Complaint Number: ${response.data.complaintNumber || '---'}`, response.data.complaintNumber );
      onReloadData( channel.id );
      onClose()
    } )
  }

  render() {
    const { onClose, open } = this.props;

    return (
      <Modal closeOnEsc={false}
             closeOnOverlayClick={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="addIMS"/></h5>

        <Form onSubmit={this.submitForm}
              defaultValues={{ 
                imsLandmark: this.state.landmark, 
                codProvince: this.state.codProvince,
                codLocation: this.state.codLocation,
                codDivision: this.state.codDivision,
                codDistrict: this.state.codDistrict,
                phoneNumber: this.state.phoneNumber,
                codStreet: this.state.codStreet,
                imsNature: this.state.imsNature , 
                imsScope: this.state.imsScope, 
                registerComment: this.state.registerComment
              }}
              validate={( values ) => ( {
                phoneNumber: required( values.phoneNumber ),
                imsNature: required( values.imsNature ),
                imsScope: required( values.imsScope ),
                // imsLandmark: required( values.imsLandmark ),
                codDistrict: required( values.codDistrict ),
                codDivision: required( values.codDivision ),
                codLocation: required( values.codLocation ),
                codProvince: required( values.codProvince ),
                codStreet: required( values.codStreet ),
                registerComment: required( values.registerComment ),

              } )}
        >
          {( { setValue, getValue, submitForm } ) =>
            <form onSubmit={submitForm}>

              <div className="row">
                <FormGroup containerClass="col-md-4">
                  <label><Translate id="imsProvince"/></label>
                  <Select field="codProvince" className="form-control" placeholder=""
                          labelKey="description"
                          valueKey="cod_prov"
                          onChange={this.setDistrict}
                          options={this.state.options2.province}/>
                </FormGroup>
                <FormGroup containerClass="col-md-4">
                  <label><Translate id="imsDistrict"/></label>
                  <Select field="codDistrict" className="form-control" placeholder=""
                          labelKey="description"
                          valueKey="cod_dist"
                          onChange={this.setDivision}
                          options={this.state.districs}/>
                </FormGroup>
                <FormGroup containerClass="col-md-4">
                  <label><Translate id="imsDivision"/></label>
                  <Select field="codDivision" className="form-control" placeholder=""
                          labelKey="description"
                          valueKey="cod_div"
                          onChange={this.setLocation}
                          options={this.state.divisions}/>
                </FormGroup>
              </div>

              <div className="row">

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="imsLocation"/></label>
                  <Select field="codLocation" className="form-control" placeholder=""
                          labelKey="description"
                          valueKey="cod_loc"
                          onChange={this.setStreet}
                          options={this.state.locations}/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="imsStreet"/></label>
                  <Select field="codStreet" className="form-control" placeholder=""
                          labelKey="description"
                          valueKey="cod_street"
                          options={this.state.streets}/>
                </FormGroup>
              </div>

              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="phone"/></label>
                  <Text field="phoneNumber" className="form-control"/>
                </FormGroup>
              </div>
              

              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="imsNature"/></label>
                  <Select field="imsNature" className="form-control" placeholder=""
                          labelKey="nature"
                          options={this.state.options.nature}/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="imsScope"/></label>
                  <Select field="imsScope" className="form-control" placeholder=""
                          labelKey="scope"
                          options={this.state.options.scope}/>
                </FormGroup>
              </div>

              <FormGroup>
                <label><Translate id="imsComment"/></label>
                <Textarea field="registerComment" className="form-control"/>
              </FormGroup>


              <div className="row">
                <FormGroup containerClass="col-md-12">
                  <label><Translate id="landmark"/></label>
                  <Textarea field="imsLandmark" className="form-control"/>
                </FormGroup>
              </div>

              <div className="text-right">
                <button className="btn btn-info"><Translate id="submit"/></button>
              </div>
            </form>
          }
        </Form>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message, msgToCopy ) => {
    dispatch( toggleAlertError( message, msgToCopy ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( AddImsNoAccountModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/AddImsNoAccountModal/index.js